import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import "@/components"
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.config.productionTip = false

// Initialize AOS
AOS.init({
  duration: 800,
  easing: 'ease-in-out',
  once: true,
  offset: 50
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
